<template>
    <div>
        <form-row title="Other Contacts" :no_border="true" class="mt-6">
            <div>
                <p v-if="! read_only"
                    class="text-gray-warm-800 text-base mb-0"
                >
                    {{ $t('Add somebody else to be notified of happenings regarding your property.') }}
                </p>

                <div v-for="(contact, index) in buyer_contacts" :key="contact.id" class="flex items-start">
                    <buyer-contact
                        field="buyer_contact"
                        :index="index"
                        :contact="contact"
                        :read_only="read_only"
                    />

                    <div
                        v-if="! read_only"
                        class="cursor-pointer flex hover:text-red-600 items-center text-gray-400 ml-2 mt-16 pt-1 sm:pt-2 px-2"
                        @click="removeContact(contact.id)"
                    >
                        <i class="fas fa-minus-circle"></i>
                    </div>
                </div>
            </div>
        </form-row>

        <button v-if="! read_only"
            type="button"
            class="flex items-center text-xs uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none ml-auto sm:ml-46 my-4"
        >
            <span class="text-lg font-bold mr-2">+</span>

            <span class="inline-block py-2 cursor-pointer select-none"
                @click="addContact"
            >
                {{ $t('Add other contact') }}
            </span>
        </button>

        <div v-else
            class="h-6 w-full"
        >
        </div>

        <div class="border-b border-gray-400"></div>
    </div>
</template>

<script>
import BuyerContact from './buyer-contact.vue';

export default {
    components: {
        BuyerContact,
    },

    props: {
        contacts: { default: () => [] },
        read_only: { default: false },
    },

    data() {
        return {
            buyer_contacts: this.contacts,
            next_id: 1,
        }
    },

    methods: {
        addContact() {
            this.buyer_contacts.push({
                id: 'id_' + this.next_id++,
                name: null,
                email: null,
                phone: null,
            })
        },
        removeContact(id) {
            this.buyer_contacts.splice(this.buyer_contacts.findIndex(contact => contact.id == id), 1);
        },
    },
}
</script>
